import { render, staticRenderFns } from "./FreeProduct.vue?vue&type=template&id=2de7ad90&scoped=true&"
import script from "./FreeProduct.vue?vue&type=script&lang=js&"
export * from "./FreeProduct.vue?vue&type=script&lang=js&"
import style0 from "./FreeProduct.vue?vue&type=style&index=0&id=2de7ad90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de7ad90",
  null
  
)

export default component.exports